import React, { useState, useContext, useEffect } from "react";
import AppContext from "context/Context";
import { Accordion, Card, Col, Container, Form, Row, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styles from "./landing.module.css";
import { getAllDatabaseRecords } from "components/workflow/WorkflowHelper";
import ContactCards from "./ContactCards";
import * as Constants from "../../../common/constants";
import { GetContactInfo } from "common/general";

document.addEventListener("DOMContentLoaded", function () {
	const cssToRemove = document.getElementById("css-to-remove");
	if (cssToRemove) {
		cssToRemove.parentNode.removeChild(cssToRemove);
	}
});

const Contact = () => {
	const {
		config: { isDark, isRTL },
	} = useContext(AppContext);
	const [t] = useTranslation();
	const [loading, setLoading] = useState(false);

	const [contacts, setContacts] = useState([]);
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		phone: "",
		type: "Inquiry", // default value
		message: "",
	});
	const [status, setStatus] = useState(null);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (loading) return; // extra protection

		setLoading(true);
		try {
			const response = await fetch(Constants.SendContactMessage, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(formData),
			});

			const result = await response.json();

			if (response.ok && result.status === 1) {
				// alert("Your message has been sent successfully.");
				setFormData({ name: "", email: "", phone: "", type: "Inquiry", message: "" });
				setStatus("success");
			} else {
				setStatus("error");
			}
		} catch (error) {
			console.error(error);
			alert("Error sending message. Please try again later.");
			setStatus("error");
		} finally {
			setLoading(false); // re-enable button
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await GetContactInfo();
				if (response?.data?.dataBaseContent) {
					const mappedData = response.data.dataBaseContent.map((item) => ({
						id: item.id,
						title: t(item.title),
						image: item.image,
						description: t(item.description),
						order: item.order,
					}));
					const sortedData = mappedData.sort((a, b) => a.order - b.order);
					setContacts(sortedData);
				} else {
					console.error("Invalid response structure:", response);
				}
			} catch (error) {
				console.error("Error fetching contact data:", error);
			}
		};

		fetchData();
	}, [t]);

	return (
		<div className={`${styles.backgroundWhite}`}>
			<Container className={`pt-5 pb-5`}>
				<h2 className={`${isRTL ? styles.landingTitleAr : styles.landingTitle} mb-4`}>{t("Contact us")}</h2>

				{/* ✅ Contact Form */}
				<Form onSubmit={handleSubmit} className={`${styles.contactForm} mb-5`}>
					<Row className="mb-3">
						<Col md={6}>
							<Form.Group controlId="contactName">
								<Form.Label>{t("Name")}</Form.Label>
								<Form.Control type="text" name="name" value={formData.name} onChange={handleChange} required />
							</Form.Group>
						</Col>
						<Col md={6}>
							<Form.Group controlId="contactEmail">
								<Form.Label>{t("Email")}</Form.Label>
								<Form.Control type="email" name="email" value={formData.email} onChange={handleChange} required />
							</Form.Group>
						</Col>
					</Row>

					<Row className="mb-3">
						<Col md={6}>
							<Form.Group controlId="contactPhone">
								<Form.Label>{t("Phone Number")}</Form.Label>
								<Form.Control type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
							</Form.Group>
						</Col>
						<Col md={6}>
							<Form.Group controlId="contactType">
								<Form.Label>{t("Type")}</Form.Label>
								<Form.Select name="type" value={formData.type} onChange={handleChange} required>
									<option value="Inquiry">{t("Inquiry")}</option>
									<option value="Suggestions">{t("Suggestions")}</option>
									<option value="Complaint">{t("Complaint")}</option>
								</Form.Select>
							</Form.Group>
						</Col>
					</Row>

					<Form.Group controlId="contactMessage" className="mb-3">
						<Form.Label>{t("Message")}</Form.Label>
						<Form.Control as="textarea" rows={4} name="message" value={formData.message} onChange={handleChange} required />
					</Form.Group>
					{status === "success" && <div className="alert alert-success mt-3">{t("Message sent successfully!")}</div>}
					{status === "error" && <div className="alert alert-danger mt-3">{t("Something went wrong. Please try again later.")}</div>}
					<Button variant="primary" type="submit" disabled={loading}>
						{loading ? t("Sending...") : t("submit")}
					</Button>
				</Form>
			</Container>

			{/* ✅ Contact Cards */}
			{contacts.length > 0 && (
				<div className={`${styles.cantactGreenBackground}`}>
					<Container className={`pt-5 pb-5`}>
						<Row className={`d-flex align-items-stretch ${styles.cantactGreenBackground}`}>
							<h2 className={`${isRTL ? styles.landingTitleAr : styles.landingTitle} mb-4`}>{t("Other means of Contact")}</h2>
							<ContactCards contacts={contacts} />
						</Row>
					</Container>
				</div>
			)}
		</div>
	);
};

export default Contact;
